<template>
  <div v-if="entities.length" class="rqa_entity_list" role="list" aria-label="קשור לתשובה">
    <a v-for="e in visible" :key="e.key || (e.type + ':' + e.id)" href="#" role="listitem"
       class="rqa_entity_item" :class="'rqa_entity_' + e.type" :title="titleOf(e)" @click.prevent="open(e)"
       @mouseenter="peek(e)" @mouseleave="unpeek">{{ chipLabel(e) }}</a>
    <a v-if="hidden > 0" href="#" class="rqa_entity_item rqa_entity_more" @click.prevent="showAll = true">עוד {{ hidden }}</a>
  </div>
</template>

<script>
// Entities the answer refers to without naming them inline (sources only):
// a short vertical list of links, three at first, then "עוד N".
import { entityChipLabel, entityTitle } from '@/utils/recruiterQaEntities'
import openEntity from './openEntity'

export const LIST_CAP = 3

export default {
  name: 'RecruiterQaEntityChips',
  mixins: [openEntity],
  props: {
    entities: { type: Array, default: () => [] }
  },
  data () {
    return { showAll: false }
  },
  computed: {
    visible () { return this.showAll ? this.entities : this.entities.slice(0, LIST_CAP) },
    hidden () { return Math.max(0, this.entities.length - this.visible.length) }
  },
  methods: {
    chipLabel (e) { return entityChipLabel(e) },
    titleOf (e) { return entityTitle(e) }
  }
}
</script>

<style scoped>
.rqa_entity_list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin: 4px 0 2px;
}
.rqa_entity_item {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px;
  padding: 1px 8px;
  border-radius: 10px;
  border: 1px solid #cfdcf3;
  background: #f3f7fd;
  color: #1f5fbf;
  text-decoration: none;
  cursor: pointer;
}
.rqa_entity_item:hover, .rqa_entity_item:focus {
  background: #e6eefb;
  outline: none;
}
.rqa_entity_more {
  border-style: dashed;
  background: transparent;
}
</style>
